import React, { useEffect, useState } from "react";
import { MdOutlineAssessment } from "react-icons/md";
import AxiosService from "../../../Utils/AxiosService";
import LocalStorageService from "../../../Auth/auth_service/AuthServiceStorage";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ReportFilter = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [client, setClient] = useState("");
  const [clientList, setClientList] = useState([]);
  const [country, setCountry] = useState("");
   const [filter, setFilter] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [reportData, setReportData] = useState({}); 
  const [loading, setLoading] = useState(false);

  const apiService = new AxiosService();
  const authVal = LocalStorageService.getAuthDetails();

  useEffect(() => {
    let authDetails = JSON.parse(authVal);

    apiService
      .getAllClientsNameForSpecificUser(authDetails.id)
      .then((response) => {
        const data = response.data;
        setClientList(Object.values(data || {}));
      });

    apiService.getAllCounties().then((response) => {
      const data = response.data;
      console.log(data)
      setCountryList(Object.values(data || {}));
    });
  }, []);

 const handleSubmit = () => {
  if (!fromDate) {
    toast.error("Please select From Date..!!");
    return;
  }
  if (!toDate) {
    toast.error("Please select To Date..!!");
    return;
  }
  if (!client) {
    toast.error("Please select Client..!!");
    return;
  }
  //  if (!filter) {
  //   toast.error("Please select Report Filter..!!");
  //   return;
  // }
  setLoading(true);

  apiService
    .getTurnAroundTimeReport(fromDate, toDate, client, country)
    .then((response) => {
      console.log(response.data);

      const data = response.data || {};

      // ✅ Correct empty check
      if (Object.keys(data).length === 0) {
        toast.info("No Data Found..!!");
      }

      setReportData(data);
    })
    .catch(() => {
      toast.error("Error fetching report");
      setReportData({});
    })
    .finally(() => {
      setLoading(false);
    });
};

const exportToExcel = () => {
  // ✅ Calculate TAT days same as table
  const tatDays = (() => {
    const allDays = Object.values(reportData).flatMap(bucketMap =>
      Object.keys(bucketMap).map(Number)
    );
    const maxDay = Math.max(...allDays, 1);
    return Array.from({ length: maxDay }, (_, i) => i + 1);
  })();

  const excelData = [];

  // Header Row
  const header = ["Client", ...tatDays.map(day => `${day} Day`), "Total"];
  excelData.push(header);

  let grandTotal = 0;

  // Calculate totals
  const projectTotals = {};
  Object.entries(reportData).forEach(([project, bucketMap]) => {
    const total = tatDays.reduce(
      (sum, day) => sum + (bucketMap[day] || 0),
      0
    );
    projectTotals[project] = total;
    grandTotal += total;
  });

  // Body Rows
  Object.entries(reportData).forEach(([project, bucketMap]) => {
    const row = [project];

    tatDays.forEach((day) => {
      row.push(bucketMap[day] || 0);
    });

    row.push(projectTotals[project]);

    excelData.push(row);
  });

  // Total Row
  const totalRow = ["Total"];
  const columnTotals = {};

  tatDays.forEach(day => {
    columnTotals[day] = Object.values(reportData).reduce(
      (sum, bucketMap) => sum + (bucketMap[day] || 0),
      0
    );
    totalRow.push(columnTotals[day]);
  });

  totalRow.push(grandTotal);
  excelData.push(totalRow);

  // Percentage Row
  const percentRow = ["%"];

  tatDays.forEach(day => {
    const percent = grandTotal > 0
      ? ((columnTotals[day] / grandTotal) * 100).toFixed(2)
      : 0;
    percentRow.push(percent);
  });

  percentRow.push("100");
  excelData.push(percentRow);

  // ✅ Create Sheet
  const worksheet = XLSX.utils.aoa_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  // ✅ Download
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(blob, "Turnaround_Report.xlsx");
};

  return (
    <div className="container mt-4">
      {/* FILTER CARD */}
      <div className="card shadow-sm border-0">
        <div className="card-body">
          <h5 className="mb-4 fw-bold text-primary">
            <MdOutlineAssessment className="me-2" />
            Report Filter
          </h5>

          <div className="row g-3 align-items-end">
            {/* From Date */}
            <div className="col-md-3">
              <label className="form-label fw-semibold">
                From Date <span className="text-danger" style={{ fontSize: "20px", fontWeight: "900", cursor: "pointer" }}title="This is a mandatory field">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>

            {/* To Date */}
            <div className="col-md-3">
              <label className="form-label fw-semibold">
                To Date <span className="text-danger" style={{ fontSize: "20px", fontWeight: "900", cursor: "pointer" }}title="This is a mandatory field">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>

            {/* Client */}
            <div className="col-md-3">
              <label className="form-label fw-semibold">
                Client <span className="text-danger" style={{ fontSize: "20px", fontWeight: "900", cursor: "pointer" }}title="This is a mandatory field">*</span>
              </label>
              <select
                className="form-select"
                value={client}
                onChange={(e) => setClient(e.target.value)}
              >
                <option value="">Select Client</option>
                <option value="all">All Clients</option>
                {clientList.map((c, index) => (
                  <option key={index} value={c}>
                    {c}
                  </option>
                ))}
              </select>
            </div>

            {/* Country */}
            <div className="col-md-3">
              <label className="form-label fw-semibold">Country</label>
              <select
                className="form-select"
                value={country}
                onChange={(e) => setCountry(e.target.value)}
              >
                <option value="">Select Country</option>
                {countryList.map((c) => (
                  <option key={c.countryCode} value={c.countryCode}>
                    {c.countrName}
                  </option>
                ))}
              </select>
            </div>

            {/* BUTTON */}
            <div className="col-md-3 d-flex justify-content-center align-items-end">
              <button
                className="btn btn-success w-100 d-flex align-items-center justify-content-center"
                onClick={handleSubmit}
                style={{ height: "38px" }}
              >
                <MdOutlineAssessment className="me-2" />
                Generate Report
              </button>
            </div>
          </div>
        </div>
      </div>

{!loading && Object.keys(reportData).length > 0 && (
  <div className="card mt-4 shadow-sm">

    <h6 className="fw-bold mb-3 text-primary text-center">
      📊 <u>Turnaround Time Report</u>
    </h6>

    <div className="col-12 d-flex justify-content-end mt-1 pe-2">
      <button
        className="btn btn-success"
        onClick={exportToExcel}
        style={{ height: "38px", minWidth: "150px" }}
      >
        Export Excel
      </button>
    </div>

    <div className="card-body">
      {(() => {

        // ✅ Continuous dynamic columns (1 → max)
        const tatDays = (() => {
          const allDays = Object.values(reportData).flatMap(bucketMap =>
            Object.keys(bucketMap).map(Number)
          );
          const maxDay = Math.max(...allDays, 1);
          return Array.from({ length: maxDay }, (_, i) => i + 1);
        })();

        // Row totals
        const projectTotals = {};
        let grandTotal = 0;

        Object.entries(reportData).forEach(([project, bucketMap]) => {
          const total = tatDays.reduce(
            (sum, day) => sum + (bucketMap[day] || 0),
            0
          );
          projectTotals[project] = total;
          grandTotal += total;
        });

        // Column totals
        const columnTotals = {};
        tatDays.forEach(day => {
          columnTotals[day] = Object.values(reportData).reduce(
            (sum, bucketMap) => sum + (bucketMap[day] || 0),
            0
          );
        });

        return (
          <div className="table-responsive">
            <table className="table table-bordered text-center">

              {/* HEADER */}
              <thead>
                <tr style={{ backgroundColor: "#e6e6e6", fontWeight: "bold" }}>
                  <th>Client</th>
                  {tatDays.map(day => (
                    <th key={day}>{day} Day</th>
                  ))}
                  <th>Total</th>
                </tr>
              </thead>

              {/* BODY */}
              <tbody>
                {Object.entries(reportData).map(([project, bucketMap]) => (
                  <tr key={project}>
                    <td className="fw-bold text-uppercase">{project}</td>

                    {tatDays.map(day => (
                      <td key={day}>{bucketMap[day] || ""}</td>
                    ))}

                    <td className="fw-bold">{projectTotals[project]}</td>
                  </tr>
                ))}

                {/* TOTAL ROW */}
                <tr style={{ backgroundColor: "yellow", fontWeight: "bold" }}>
                  <td>Total</td>
                  {tatDays.map(day => (
                    <td key={day}>{columnTotals[day]}</td>
                  ))}
                  <td>{grandTotal}</td>
                </tr>

                {/* % ROW */}
                <tr style={{ backgroundColor: "#d9ead3", fontWeight: "bold" }}>
                  <td>%</td>
                  {tatDays.map(day => {
                    const percent = grandTotal > 0
                      ? ((columnTotals[day] / grandTotal) * 100).toFixed(2)
                      : 0;
                    return <td key={day}>{percent}</td>;
                  })}
                  <td>100</td>
                </tr>

              </tbody>
            </table>
          </div>
        );
      })()}
    </div>
  </div>
)}
{loading && (
  <div className="text-center mt-4">
    <div className="spinner-border text-primary" role="status"></div>
    <p className="mt-2">Loading report...</p>
  </div>
)}
    </div>
  );
};

export default ReportFilter;